const steps = [
  { icon: 'ri-file-upload-line', step: 'PASSO 1', title: 'Envie seu histórico' },
  { icon: 'ri-shield-check-line', step: 'PASSO 2', title: 'Validamos os dados' },
  { icon: 'ri-line-chart-line', step: 'PASSO 3', title: 'Projetamos a demanda' },
  { icon: 'ri-list-check-2', step: 'PASSO 4', title: 'Receba a lista de compra' },
];

export default function HeroSection() {
  return (
    <section className="bg-zinc-950 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-4xl mx-auto">
          <span className="inline-block font-sora font-semibold text-emerald-400 text-xs md:text-sm uppercase tracking-widest mb-6">
            Diagnóstico de demanda e compras para varejo e indústria
          </span>
          <h1 className="font-sora font-bold text-4xl md:text-6xl text-white leading-tight mb-6">
            Ruptura é venda perdida.
            <br />
            Excesso é capital parado.
          </h1>
          <p className="font-inter text-zinc-400 text-base md:text-lg max-w-2xl mx-auto mb-10">
            Envie o histórico de vendas, estoque e compras da sua empresa — em CSV ou
            Excel. Em até 30 dias, você recebe a lista de produtos em risco e a
            sugestão de quanto comprar de cada um.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
            <a
              href="#solicitar"
              className="w-full sm:w-auto bg-emerald-500 hover:bg-emerald-600 text-white px-8 py-4 rounded-full font-semibold font-sora text-base transition-all cursor-pointer whitespace-nowrap"
            >
              Solicitar diagnóstico
            </a>
            <a
              href="#como-funciona"
              className="inline-flex items-center gap-2 text-zinc-300 hover:text-white font-inter text-base transition-colors cursor-pointer"
            >
              Como funciona
              <i className="ri-arrow-down-line" aria-hidden="true" />
            </a>
          </div>
        </div>

        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-16">
          {steps.map((item) => (
            <li
              key={item.step}
              className="bg-zinc-900 border border-zinc-800 rounded-2xl p-5"
            >
              <div
                className="w-10 h-10 flex items-center justify-center rounded-xl bg-emerald-500/10 border border-emerald-500/20 mb-4"
                aria-hidden="true"
              >
                <i className={`${item.icon} text-emerald-400`} />
              </div>
              <span className="block font-inter text-zinc-500 text-xs uppercase tracking-widest mb-1">
                {item.step}
              </span>
              <span className="block font-sora font-semibold text-white text-sm">
                {item.title}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
